import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { ErrorService } from 'app/common/services/error.service';
import { Table } from 'app/shared/models';
import { BehaviorSubject } from 'rxjs';
import { ColumnMapperInterface, OdataColumnMapper } from './column-mapper';
import { DataApiContext } from './data-api-context';
import { Filterable } from './data-api-interfaces';
import { GridApiContext } from './grid-api-context';

@Injectable({
  providedIn: 'root'
})
export class DataApi {
  private http = inject(HttpClient);
  private errorService = inject(ErrorService);

  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;

  public get<t>(table: Table | string, mapper?: OdataColumnMapper<t>, limitSelectToMapper: boolean = false, state?: State | string, cache: Map<string, t[]> = null): Promise<t[]> {
    return new DataApiContext<t>(this.http, this.BASE_URL, table, mapper, this.errorService, true).query(limitSelectToMapper, state, null, null, null, cache);
  }

  public getApiService<t>(table: Table | string, mapper?: ColumnMapperInterface<t>): DataApiContext<t> {
    return new DataApiContext(this.http, this.BASE_URL, table, mapper, this.errorService, false);
  }

  public getService<t>(table: Table | string, mapper?: ColumnMapperInterface<t>,
    limitSelectToMapper: boolean = false, state?: State
  ): DataApiContext<t> {
    return new DataApiContext(this.http, this.BASE_URL, table, mapper, this.errorService, true);
  }

  public grid(table: Table | string, filter?: Filterable, expand?: string, tableIDField: string = null): BehaviorSubject<GridDataResult> {
    return new GridApiContext(this.http, this.BASE_URL, table, filter, expand, this.errorService, tableIDField).query();
  }

  public gridService(table: Table | string, filter?: Filterable, expand?: string, tableIDField: string = null): GridApiContext {
    return new GridApiContext(this.http, this.BASE_URL, table, filter, expand, this.errorService, tableIDField);
  }
}